import { render, staticRenderFns } from "./adres.vue?vue&type=template&id=544f8b8e"
import script from "./adres.vue?vue&type=script&lang=js"
export * from "./adres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports